export default "__VITE_ASSET__24c9cf67__"